import dayjs, { dateInputFieldFormat } from '~libs/dayjs';

import { Step } from '~components/wizard-form/props';

import Confirm from '../../components/co-contributions/co-contributions-wizard/Confirm';
import Review from '../../components/co-contributions/co-contributions-wizard/Review';

const steps: Step[] = [
  {
    step: 1,
    title: 'Criteria',
    fields: {
      invoice_date: {
        type: 'date',
        caption: 'Invoice Date',
        description: 'Collate all approved co-contribution amounts from payment summaries not yet invoiced.',
        className: 'align-items-baseline',
        maxDate: () => dayjs().format(dateInputFieldFormat),
        required: true,
      },
      due_date: {
        type: 'date',
        caption: 'Due Date',
        className: 'align-items-baseline',
        minDate: () => dayjs().format(dateInputFieldFormat),
        required: true,
      },
      service_date_to: {
        type: 'date',
        caption: 'Include services up to',
        description: 'Defaults to Invoice Date when blank.',
        className: 'align-items-baseline',
      },
    },
  },
  {
    step: 2,
    title: 'Confirm',
    nextButtonCaption: 'Confirm',
    showNextButton: ({ values }) => {
      // Only allow next step if there are uninvoiced clients for the selected dates
      const estimateData = values?.confirm?.data;
      return (estimateData?.clients?.length ?? 0) > 0;
    },
    fields: {
      confirm: {
        type: 'custom',
        component: Confirm,
        colSize: 12,
        dependencies: ['invoice_date', 'service_date_to'],
      },
    },
  },
  {
    step: 3,
    title: 'Review',
    showPrevButton: false,
    fields: {
      review: {
        type: 'custom',
        component: Review,
        colSize: 12,
        dependencies: ['invoice_date', 'due_date', 'service_date_to'],
      },
    },
  },
];

export default steps;
